import { Injectable } from '@angular/core';

export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'admin-theme';
const ORDER: ThemePreference[] = ['system', 'light', 'dark'];

/**
 * Light / dark / system theme for the admin. The choice is a per-browser convenience, so it lives
 * in localStorage; `data-theme` on <html> drives the CSS tokens in styles.scss.
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private current: ThemePreference = 'system';

  constructor() {
    this.apply(this.read());
  }

  get preference(): ThemePreference {
    return this.current;
  }

  /** system → light → dark → system */
  cycle(): ThemePreference {
    const next = ORDER[(ORDER.indexOf(this.current) + 1) % ORDER.length];
    this.apply(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* storage blocked: keep the choice for this visit */ }
    return next;
  }

  private read(): ThemePreference {
    try {
      const stored = localStorage.getItem(STORAGE_KEY) as ThemePreference | null;
      return stored && ORDER.includes(stored) ? stored : 'system';
    } catch {
      return 'system';
    }
  }

  private apply(preference: ThemePreference): void {
    this.current = preference;
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    if (preference === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', preference);
  }
}
